import App from './App.vue'

import * as filters from '../../utils/filters';
Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key])//插入过滤器名和对应方法
})

import "@/utils/login";
import $utils from '../../utils'
Vue.prototype.$utils = $utils;// 公共方法

import router from './router'

// 公共js
import commonJs from '@/assets/js/common/common.js';
import '../../assets/css/iconFonts/iconfont.css';
Vue.prototype.$commonJs = commonJs;

Vue.config.productionTip = false

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

import store from './store'

window.jdLoginTools_create_by_team_aris.initLoginState($utils.loginOptions);

window.$vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
